// ===============================================================================
// Arena Customization Set Product
// ===============================================================================
// string is copied from the live theme
theme.strings = {
  addToCart: "Add to cart",
  soldOut: "Sold out",
  unavailable: "Unavailable",
  stockLabel: "Translation missing: en.products.product.stock_label",
  willNotShipUntil: "Translation missing: en.products.product.will_not_ship_until",
  willBeInStockAfter: "Translation missing: en.products.product.will_be_in_stock_after",
  waitingForStock: "Translation missing: en.products.product.waiting_for_stock",
  savePrice: "Save [saved_amount]",
  cartEmpty: "Your cart is empty",
  cartTermsConfirmation: "You must agree with the terms and conditions of sales to check out",
  // searchCollections: "Translation missing: en.general.search.collections",
  searchPages: "Translation missing: en.general.search.pages",
  searchArticles: "Articles"
};
// settings is copied from the live theme
theme.settings = {...theme.settings,
  "dynamicVariantsEnable": true,
  "dynamicVariantType": "button",
  "cartType": "drawer",
  "isCustomerTemplate": false,
  "moneyFormat": " USD",
  "saveType": "percent",
  "recentlyViewedEnabled": true,
  "productImageSize": "portrait",
  "productImageCover": false,
  "predictiveSearch": true,
  "predictiveSearchType": "product",
  "inventoryThreshold": 10,
  "quickView": true,
  "overlayHeader": false
}
const ARNCUSTOM = {
  selectors: {
    container: 'section.product-section',
    containerInQuickView: '.product-information--inner.product-information-inner-quick-view',
    addToCart: '.add-to-cart', // old theme: .add-to-cart, new theme is .single-add-to-cart-button
    addToCartInTemplate: '.template-product .add-to-cart',
  }
  ,
  methods: {
    closeQuickView: function() {
        // dispatchCustomEvent('panel:close'); // customElements with side-panel-close
        let panel = document.getElementById('Product-Drawer');
        panel.classList.remove('active')
        panel.querySelector('#Product-Drawer-Content').innerHTML = ''
        document.body.classList.remove('open-quick-view')
        if (document.body.classList.contains('open-cart') && !document.body.classList.contains('open-cc')) {
            document.body.classList.add('open-cc');
        }
    },
    refreshCartDrawer: function(showCartDrawer = true) {
        this.CartDrawer = window.CartDrawerCustomElement || null
        if (!this.CartDrawer) {
            // this.CartDrawer = new CartDrawer()
            let cartDrawerConstructor = customElements.get('cart-drawer');
            if (cartDrawerConstructor) {
                this.CartDrawer = new cartDrawerConstructor();
            }
        }
        if (!this.CartDrawer) {
            console.log('===** Error CartDrawer is not valid');
            return false;
        }
        this.CartDrawer.refresh();
        if (showCartDrawer && !document.body.classList.contains('open-cart')) {
            this.showCartDrawer();
        }
        // add black background if not have open-cc
        if (document.body.classList.contains('open-cart') && !document.body.classList.contains('open-cc')) {
            document.body.classList.add('open-cc');
        }
    },
    showCartDrawer: function() {
        let CartDrawerEl = document.getElementById('Cart-Drawer')
        if (CartDrawerEl) {
            CartDrawerEl.classList.add('active');
            document.body.classList.add('open-cart', 'open-cc');
            let productRecommendFullEl = CartDrawerEl.querySelector('.product-recommendations--full');
            if (productRecommendFullEl) {
                productRecommendFullEl.classList.add('active');
            }
            dispatchCustomEvent('cart-drawer:open');
        }
    },
  }
}
// Arena copied theme.QtySelector
theme.QtySelector = (function() {
    var classes = {
        input: '.js-qty__num',
        plus: '.js-qty__adjust--plus',
        minus: '.js-qty__adjust--minus'
    };

    function QtySelector($el, options) {
        this.$wrapper = $el;
        this.$input = $el.find(classes.input);
        this.$plus = $el.find(classes.plus);
        this.$minus = $el.find(classes.minus);
        this.minValue = this.$input.attr('min') || 1;

        var defaults = {
            namespace: null,
            key: this.$input.data('id')
        };

        this.options = $.extend(defaults, options);

        this.initEventListeners();
    };

    QtySelector.prototype = $.extend({}, QtySelector.prototype, {
        initEventListeners: function() {
            this.$plus.on('click', function() {
                var qty = this.validateQty(this.$input.val());
                this.addQty(qty);
            }.bind(this));

            this.$minus.on('click', function(event) {                    
                event.preventDefault(); // Thanh update 23/04/2021 task 1
                event.stopPropagation();
                var qty = this.validateQty(this.$input.val());
                this.subtractQty(qty);
            }.bind(this));

            this.$input.on('change', function() {
                var qty = this.validateQty(this.$input.val());
                this.changeQty(qty);
            }.bind(this));
        },

        addQty: function(number) {
            var qty = number + 1;
            this.changeQty(qty);
        },

        subtractQty: function(number) {
            
            var qty = number - 1;
            if (qty <= this.minValue) {
                qty = this.minValue;
            }
            this.changeQty(qty);
        },

        changeQty: function(qty) {
            this.$input.val(qty);
              
            $('body').trigger('qty' + this.options.namespace, [this.options.key, qty]);
        },

        validateQty: function(number) {
            if ((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
                // We have a valid number!
            } else {
                // Not a number. Default to 1.
                number = 1;
            }
            return parseInt(number);
        }
    });

    return QtySelector;
})();
// Arena copied theme.AjaxProduct
theme.AjaxProduct = (function() {
  var status = {
      loading: false
  };

  function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find(ARNCUSTOM.selectors.addToCart);
      if (this.$form.length) {
          this.$form.on('submit', this.addItemFromForm.bind(this));
      }
  };

  ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback) {
          evt.preventDefault();
            //   if (status.loading) {
            //       return;
            //   }

          // Loading indicator on add to cart button
          this.$addToCart.addClass('btn--loading');

          status.loading = true;

          var data = this.$form.serialize();

          // ArenaCommerce override add to cart function
          var groupFlag = this.$form.find('.group-product').length;
          var _this = this;
          if (groupFlag) {
              theme.cart.groupAddCart(_this.$form, function(result) { // 09/24/24 Thanh add _this.$form
                  _this.$addToCart.removeClass('btn--loading');
                  status.loading = false;
                    //update the cart free shipping bar sankalp
                    //theme.ShippingBar.update();
                  if(result.status == 'error') {
                      alert(result.msg);
                  } else {
                      _this.success(result.products);
                  }
              })
          } else {
              // Check pad option on top product
              if($("#buy-with-pad").length && $("#buy-with-pad").is(':checked')) {
                  var items = [];
                  items.push({
                      quantity: 1,
                      id: $("#buy-with-pad").val(),  
                  })
                  $.ajax({
                      url: '/cart/add.js',
                      type: 'POST',
                      data: {items: items},
                      dataType: 'json',
                      error: function(err) {
                          _this.error({
                              status: 'error',
                              msg: 'Cannot add pad product',
                          })
                      },
                      success: function(products) {
                          ARNCUSTOM.methods.refreshCartDrawer();
                          theme.cart.addItemFromForm(data)
                          .then(function(product) {
                              this.success(product);
                          }.bind(_this))
                          .catch(function(XMLHttpRequest) {
                              this.error(XMLHttpRequest)
                          }.bind(_this))
                          .always(function() {
                              status.loading = false;
                              this.$addToCart.removeClass('btn--loading');
                            //update the cart free shipping bar sankalp
                             //theme.ShippingBar.update();
                          }.bind(_this));
                      }
                  })
              } else {
                  theme.cart.addItemFromForm(data)
                  .then(function(product) {
                      this.success(product);
                  }.bind(this))
                  .catch(function(XMLHttpRequest) {
                      this.error(XMLHttpRequest)
                  }.bind(this))
                  .always(function() {
                      status.loading = false;
                      this.$addToCart.removeClass('btn--loading');
                      //update the cart free shipping bar sankalp
                       //theme.ShippingBar.update();
                  }.bind(this));
              }
              
          }                
      },

      success: function(product) {
          this.$form.find('.errors').remove();
          $('body').trigger('added.ajaxProduct', this.$addToCart);
      },

      error: function(XMLHttpRequest) {
          this.$form.find('.errors').remove();

          if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
              this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
          }
      }
  });

  return ProductForm;
})();
// Arena Customization Variant
theme.Variants = (function() {

  function Variants(options) {
      this.$container = options.$container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
      this.type_render = options.type_render;

      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

      _getCurrentOptions: function() {
          var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
              var $element = $(element);
              var type = $element.attr('type');
              var currentOption = {};

              if (type === 'radio' || type === 'checkbox') {
                  if ($element[0].checked) {
                      currentOption.value = $element.val();
                      currentOption.index = $element.data('index');

                      return currentOption;
                  } else {
                      return false;
                  }
              } else {
                  currentOption.value = $element.val();
                  currentOption.index = $element.data('index');

                  return currentOption;
              }
          });

          // remove any unchecked input values if using radio buttons or checkboxes
          currentOptions = this._compact(currentOptions);

          return currentOptions;
      },

      _getVariantFromOptions: function() {
          var selectedValues = this._getCurrentOptions();
          
          var variants = this.variants;
          var found = false;

          variants.forEach(function(variant) {
              var match = true;
              var options = variant.options;

              selectedValues.forEach(function(option) {
                  if (match) {
                      match = (variant[option.index] === option.value);
                  }
              });

              if(selectedValues.length != options.length) {
                  match = false;
              }

              if (match) {
                  found = variant;
              }
          });

          return found || null;
      },

      _onSelectChange: function() {
          var variant = this._getVariantFromOptions();
          
          this.$container.trigger({
              type: 'variantChange',
              variant: variant
          });

          if (!variant) {
              return;
          }

          if(!this.currentVariant) {
              this.currentVariant = variant;    
          }

          this._updateMasterSelect(variant);
          this._updateImages(variant);
          this._updatePrice(variant);
          this._updateUnitPrice(variant);
          this._updateSKU(variant);
          this.currentVariant = variant;

          if (this.enableHistoryState) {
              this._updateHistoryState(variant);
          }
      },

      _updateImages: function(variant) {
          
          var variantImage = variant.featured_image || {};
          var currentVariantImage = this.currentVariant.featured_image || {};

          if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
              return;
          }

          this.$container.trigger({
              type: 'variantImageChange',
              variant: variant
          });
      },

      _updatePrice: function(variant) {
          
          if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
              // Addition condition for case init curVariant is null
              if(variant != this.currentVariant)
                  return;
          }

          this.$container.trigger({
              type: 'variantPriceChange',
              variant: variant
          });
      },

      _updateUnitPrice: function(variant) {
          if (variant.unit_price === this.currentVariant.unit_price) {
              return;
          }

          this.$container.trigger({
              type: 'variantUnitPriceChange',
              variant: variant
          });
      },

      _updateSKU: function(variant) {
          if (variant.sku === this.currentVariant.sku) {
              return;
          }

          this.$container.trigger({
              type: 'variantSKUChange',
              variant: variant
          });
      },

      _updateHistoryState: function(variant) {
          if (!history.replaceState || !variant) {
              return;
          }

          var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
  window.history.replaceState({path: newurl}, '', newurl);
      },

      _updateMasterSelect: function(variant) {
          $(this.originalSelectorId, this.$container).val(variant.id);
      },

      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function(array) {
          var index = -1,
              length = array == null ? 0 : array.length,
              resIndex = 0,
              result = [];

          while (++index < length) {
              var value = array[index];
              if (value) {
                  result[resIndex++] = value;
              }
          }
          return result;
      }
  });

  return Variants;
})();
// Arena copied theme.cart
theme.cart = {
    getCart: function() {
        return $.getJSON('/cart.js');
    },
    changeItem: function(key, qty) {
        return this._updateCart({
            type: 'POST',
    url: theme.routes.cart_change_url, // old is cartChange, new is cart_change_url
            data: 'quantity=' + qty + '&id=' + key,
            dataType: 'json'
        });
    },

    addItemFromForm: function(data) {
        return this._updateCart({
            type: 'POST',
            url: theme.routes.cart_add_url, // old is cartAdd, new is cart_add_url
            data: data,
            dataType: 'json'
        });
    },

    _updateCart: function(params) {
        return $.ajax(params)
            .then(function(cart) {
                ARNCUSTOM.methods.refreshCartDrawer();
                if (document.body.classList.contains('open-quick-view')) {
                    ARNCUSTOM.methods.closeQuickView();
                }
                return cart;
            }.bind(this))
    },

    updateNote: function(note) {
        var params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + theme.cart.attributeToString(note),
            dataType: 'json',
            success: function(cart) {
            },
            error: function(XMLHttpRequest, textStatus) {}
        };

        $.ajax(params);
    },

    attributeToString: function(attribute) {
        if ((typeof attribute) !== 'string') {
            attribute += '';
            if (attribute === 'undefined') {
                attribute = '';
            }
        }
        return $.trim(attribute);
    },

    groupAddCart: function($form, callback) {
        var items = [];
        var selectors = $form.find('.bundle-item > .variants-wrapper > .product-single__variants'); // update 09/24/24 by Thanh
        var padSelector = $('#buy-with-pad');
        var gift_selector = $('.sticker-item > .variants-wrapper > .product-single__variants');
        var gift_txt = gift_selector.find('option:selected').text();
        console.log('gift_txt: ', gift_txt)
        var gift_id = gift_txt.toLowerCase().indexOf('none') == -1 ? gift_selector.val() : '';
        var group_random_id = Math.random().toString(36).substring(7);

        selectors.each(function(index, item) {
            var item = {
                quantity: 1,
                id: $(item).val(),
                properties: {
                    '_product_group': 'Group-' + group_random_id,
                }
            };
            if(index == 1) {
                if(padSelector.length && padSelector.is(':checked')) {
                    items.push({
                        quantity: 1,
                        id: padSelector.val(),
                        properties: {
                            '_product_group': 'Group-' + group_random_id,
                        }    
                    })      
                }
            }
            items.push(item);
        });

        if(gift_id) {
            items.push({
                quantity: 1,
                id: gift_id,
                properties: {
                    '_product_group': 'Group-' + group_random_id,
                }    
            })  
        }

        items.reverse();

        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            data: {items: items},
            dataType: 'json',
            error: function(xhr, textError, errorThrown ) {
                let responseJSON = xhr.responseJSON
                let msg = responseJSON && responseJSON.message && responseJSON.message.toLowerCase().includes('ready sold out') ? responseJSON.message : 'Cannot add individual product';
                callback({
                    status: 'error',
                    msg
                })
            },
            success: function(products) {
                ARNCUSTOM.methods.refreshCartDrawer();
                if (document.body.classList.contains('open-quick-view')) {
                    ARNCUSTOM.methods.closeQuickView();
                }
                callback({
                    status: 'success',
                    products: products.items,
                })
            },
        })
    }
};
// Arena Customization Currency from theme.Currency
theme.Currency = (function() {
  var moneyFormat = '$';
  var superScript = theme && theme.settings && theme.settings.superScriptPrice;

  function formatMoney(cents, format) {
    if (!format) {
      format = theme.settings.moneyFormat;
    }

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = theme.utils.defaultTo(precision, 2);
      thousands = theme.utils.defaultTo(thousands, ',');
      decimal = theme.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }
    let stringMatches = formatString.match(placeholderRegex)

    if (stringMatches && stringMatches[1]) {
      switch (stringMatches[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');

          if (superScript && value && value.includes('.')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }

          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit
  }
})();
// Arena Customization copied from theme.Images
/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */
    
theme.Images = (function() {

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
        if (!src) {
            return '620x'; // default based on theme
        }

        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

        if (match !== null) {
            return match[1];
        } else {
            return null;
        }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
        if (!src) {
            return src;
        }

        if (size == null) {
            return src;
        }

        if (size === 'master') {
            return this.removeProtocol(src);
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match != null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        }

        return null;
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }

    /**
     * Create lazyloading-friendly image string
     *
     * @param string
     * @returns string with _{width}x as size param
     */
    function lazyloadImagePath(string) {
        var image;

        if (string !== null) {
            image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
        }

        return image;
    }

    return {
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol,
        lazyloadImagePath: lazyloadImagePath
    };
})();
// Arena Customization copied theme.utils
theme.utils = {
  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value 
  },

  // Thanh update 27/04/2021 from theme.js v4.1.1
  wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
  },

  throttle: function(limit, callback) {
    var waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function () {
          waiting = false;
        }, limit);
      }
    }
  },

  prepareTransition: function(el, callback) {
    el.addEventListener('transitionend', removeClass);

    function removeClass(evt) {
      el.classList.remove('is-transitioning');
      el.removeEventListener('transitionend', removeClass);
    }

    el.classList.add('is-transitioning');
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === 'function') {
      callback();
    }
  },

  // _.compact from lodash
  // Creates an array with all falsey values removed. The values `false`, `null`,
  // `0`, `""`, `undefined`, and `NaN` are falsey.
  // _.compact([0, 1, false, 2, '', 3]);
  // => [1, 2, 3]
  compact: function(array) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize: function(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
};

// CLASS SETPRODUCT
class ArnSetProduct {
    constructor(type_render) {
        this.classes = {
            onSale: 'on-sale',
            disabled: 'disabled',
            isModal: 'is-modal',
            loading: 'loading',
            loaded: 'loaded',
            hidden: 'hide',
            interactable: 'video-interactable',
            visuallyHide: 'visually-invisible'
        };
        this.type_render = type_render;
    }    
    init() {
        this.$container = (this.type_render !== 'quick-view') ? $(ARNCUSTOM.selectors.container) : $(ARNCUSTOM.selectors.containerInQuickView);
        var $container = this.$container
        if (!$container.length) {
            return false
        }
        var sectionId = this.sectionId = $container.attr('id').replace('shopify-section-','').replace('ProductInfo-','');
        this.inModal = $container.closest('.modal').length;
        this.$modal;

        this.settings = {
            enableHistoryState: $container.data('enable-history-state') || false,
            namespace: '.product-' + sectionId,
            inventory: $container.data('inventory') || false,
            incomingInventory: $container.data('incoming-inventory') || false,
            modalInit: false,
            slickMainInitialized: false,
            slickThumbInitialized: false,
            thumbArrows: false,
            thumbVertical: false,
            hasImages: true,
            hasMultipleImages: false,
            has3d: false,
            imageSize: '620x',
            videoLooping: $container.data('video-looping')
        };

        this.selectors = {
            variantsJson: 'VariantsJson-' + sectionId,
            currentVariantJson: 'CurrentVariantJson-' + sectionId,

            video: 'ProductVideo-' + sectionId,
            media: '[data-product-media-type-model]',
            closeMedia: '.product-single__close-media',
            photoThumbs: '.product__thumb-' + sectionId,
            thumbSlider: '#ProductThumbs-' + sectionId,
            mainSlider: '#ProductPhotos-' + sectionId,
            imageContainer: '[data-product-images]',
            productImageMain: '.product-image-main--' + sectionId,
            dotsContainer: '.product__photo-dots--' + sectionId,

            priceWrapper: '.product__price-wrap-' + sectionId,
            price: '#ProductPrice-' + sectionId,
            comparePrice: '#ComparePrice-' + sectionId,
            savePrice: '#SavePrice-' + sectionId,
            priceA11y: '#PriceA11y-' + sectionId,
            comparePriceA11y: '#ComparePriceA11y-' + sectionId,
            unitWrapper: '.product__unit-price-wrapper--' + sectionId,
            unitPrice: '.product__unit-price--' + sectionId,
            unitPriceBaseUnit: '.product__unit-base--' + sectionId,
            sku: '#Sku-' + sectionId,
            inventory: '#ProductInventory-' + sectionId,
            incomingInventory: '#ProductIncomingInventory-' + sectionId,

            addToCart: '#AddToCart-' + (this.type_render !== 'quick-view' ? sectionId + '-' + this.type_render : sectionId), // old is '#AddToCart-' + sectionId
            addToCartText: '#AddToCartText-' + (this.type_render !== 'quick-view' ? sectionId + '-' + this.type_render : sectionId), // old is '#AddToCartText-' + sectionId

            originalSelectorId: '#ProductSelect-' + sectionId,
            singleOptionSelector: '.variant__input-' + sectionId,
            variantColorSwatch: '.variant__input--color-swatch-' + sectionId,

            modalFormHolder: '#ProductFormHolder-' + sectionId,
            formContainer: '#AddToCartForm-' + (this.type_render !== 'quick-view' ? sectionId + '-' + this.type_render : sectionId), // old is '#AddToCartForm-' + sectionId
        };
        this.$formContainer = $(this.selectors.formContainer);
        if (!this.$formContainer.length) {
            return false
        }
        this.initCaller();
    }
    initCaller() {
      if (this.inModal) {
        this.$container.addClass(this.classes.isModal);
        $('body')
            .off('modalOpen.QuickShopModal-' + this.sectionId)
            .off('modalClose.QuickShopModal-' + this.sectionId);
        $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
        $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
      }

      if (!this.inModal) {
          this.formSetup();
      }

      if($("#buy-with-pad").length) {
          var _this = this;
          $("#buy-with-pad").on("change", function(evt) {
              _this.updateMainPrice();
          })    
      }       
    }
    formSetup() {
      // Determine how to handle variant availability selectors
      if (theme.settings.dynamicVariantsEnable) {
          var groupProd = this.$formContainer.find(".group-product").length;
          if(!groupProd) {
              this.$variantSelectors = this.$formContainer.find(this.selectors.singleOptionSelector);
          }
      }
      this.initQtySelector();
      this.initAjaxProductForm();
      this.initVariants();
    }
    initVariants() {
        var groupProd = this.$formContainer.find(".group-product").length;
        // single product
        if(!groupProd) {
            if (!document.getElementById(this.selectors.variantsJson)) {
                return;
            }
            this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);
            
            // this.namespace is .product-<productID> label of event
            var options = {
                $container: this.$formContainer, //jquery object of product-section
                $formContainer: this.$formContainer, // 09/25/2024 add this
                enableHistoryState: this.settings.enableHistoryState,       // true-fale
                singleOptionSelector: this.selectors.singleOptionSelector, // class of hidden input
                originalSelectorId: this.selectors.originalSelectorId,     // id of selector
                variants: this.variantsObject,
                type_render: this.type_render
            };

            // Only disable cart btn if variant number > 1
            if(this.variantsObject.length > 1) {
                // $(ARNCUSTOM.selectors.addToCartInTemplate).addClass("disabled init-btn").prop("disabled", true);
                this.$formContainer.find(this.selectors.addToCart).addClass("disabled init-btn").prop("disabled", true);
            }
            
            if ($(this.selectors.variantColorSwatch).length) {
                $(this.selectors.variantColorSwatch).on('change', function(evt) {
                    var $el = $(evt.currentTarget);
                    var color = $el.data('color-name');
                    var index = $el.data('color-index');
                    this.updateColorName(color, index);
                }.bind(this));
            }

            this.variants = new theme.Variants(options);

            this.$formContainer
                .on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this))
                .on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this))
                .on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this))
                .on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this))
                // Extra function to update image and title
                .on('variantChange' + this.settings.namespace, (function(evt){
                    var variant = evt.variant;                            
                    if(!variant) return;
                    //var name = variant.name.toLowerCase();
                    var type = '';
                    // Single Product
                    if(evt.currentTarget.className.includes('product-section')) 
                    {                                
                        var urlSingle = location.href.toLowerCase();
                        if (urlSingle.indexOf('tops') != -1)
                            {
                                type = 'tops';
                            } 
                        else if (urlSingle.indexOf('bottoms') != -1)
                            {
                                type = 'bottoms';
                            }
                        else if (urlSingle.indexOf('sticker') != -1)
                        {
                            type = 'sticker';
                        }                                
                    }
                    // console.log('Type: ', type);
                    // if(name.indexOf('tops') != -1) {
                    //     type = 'tops';
                    // } else if(name.indexOf('bottoms') != -1) {
                    //     type = 'bottoms';
                    // } else if(name.indexOf('sticker') != -1) {
                    //     type = 'sticker';
                    // }
                    
                    if(type == 'bottoms' || type == 'sticker') {
                        var item_label = $(evt.currentTarget).find(".variant__label-info span");
                        
                        if(item_label.length) {
                            item_label.text(variant.options[0]);    
                        }
                    }

                    
                    setTimeout(function(){
                        var varSelector = $(evt.currentTarget).find('.product-single__variants');
                        var bottle = varSelector.find('option:selected').data("bottle");
                        var bottleMsg = $(evt.currentTarget).find('.bottle-msg');
                        if(bottle) {
                            if(bottle > 1){
                            bottleMsg.text('Made with ' + bottle + ' recycled bottles').show();
                          }
                          else{
                            bottleMsg.text('Made with ' + bottle + ' recycled bottle').show();    
                          }
                        } else {
                            bottleMsg.hide();    
                        }

                    }, 50)
                    
                }).bind(_this))
                
            if ($(this.selectors.sku).length) {
                this.$formContainer.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
            }
            if (this.settings.inventory || this.settings.incomingInventory) {
                this.$formContainer.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
            }
            
            
            // Update individual variant availability on each selection
            if (theme.settings.dynamicVariantsEnable && document.getElementById(this.selectors.currentVariantJson)) {
                this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML);

                this.$variantSelectors.on('change' + this.settings.namespace, this.updateVariantAvailability.bind(this));
                this.$variantSelectors.on('change' + this.settings.namespace, this.stripOutstock.bind(this, this.variantsObject, this.$formContainer));

                // Set default state based on current selected variant
                this.setCurrentVariantAvailability(this.currentVariantObject, true);
                // Strip outstock at load
                this.stripOutstockAtLoad(this.currentVariantObject, this.$formContainer); // 09/25/24 changed this.$container to this.$formContainer
            }
        } 
        // group products
        else {
            var bundleItems = $('.bundle-items--wrapper > div');
            var _this = this;
            var disableCart = false;
            _this.variants = [];
            bundleItems.each(function(index, item) {
                var variantObject = JSON.parse($(item).find(">textarea")[0].innerHTML);
                var currentVariantObject = $(item).find(">textarea")[1] ? JSON.parse($(item).find(">textarea")[1].innerHTML) : null;
                var prodId = $(item).data("product-id");
                
                if($(item).attr('class').indexOf('bundle-item') !== -1) {
                    if(variantObject.length > 1) {
                        disableCart = true;    
                    }
                }
                var options = {
                    $container: $(item),
                    enableHistoryState: false,
                    singleOptionSelector: '.' + $(item).find(".variant-input > input")[0].className,
                    originalSelectorId: '#' + $(item).find(".product-single__variants")[0].id,
                    variants: variantObject,
                    type_render: _this.type_render
                };
                var variant = new theme.Variants(options);
                _this.variants.push(variant);
                
                $(item)
                .on('variantChange' + '.bundle-variant-changed', _this.updateCartButton.bind(_this))
                .on('variantPriceChange' + '.bundle-variant-changed', _this.updatePrice2.bind(_this, prodId, item))
                // Extra function to update image and title
                .on('variantChange' + '.bundle-variant-changed', (function(evt){
                    var variant = evt.variant;                           
                    
                    if(!variant) return;
                    //var name = variant.name.toLowerCase();
                    var type = '';

                    if(evt.currentTarget.className.includes('sticker-item')) // sticker item
                    {
                        type = 'sticker';
                    }
                    if(evt.currentTarget.className.includes('bundle-item')) // Top or bottom, need more check
                    {                                
                        var bundelImageTagA = $(evt.currentTarget).find('.bundle-item--image > a').first();
                        if (bundelImageTagA.length > 0)
                        {
                            if (bundelImageTagA.attr('href').toLowerCase().indexOf('tops') != -1)
                            {
                                type = 'tops';
                            } else if (bundelImageTagA.attr('href').toLowerCase().indexOf('bottoms') != -1)
                            {
                                type = 'bottoms';
                                var fieldset = $(evt.currentTarget).find('fieldset.variant-input-wrap').first();                                
                                if (fieldset.length > 0) { fieldset.addClass('arn-variant-type-bottoms'); }
                            }
                        }
                    }                            
                    // if(name.indexOf('tops') != -1) {
                    //     type = 'tops';
                    // } else if(name.indexOf('bottoms') != -1) {
                    //     type = 'bottoms';
                    // } else if(name.indexOf('sticker') != -1) {
                    //     type = 'sticker';    
                    // }
                    
                    if(type == 'bottoms' || type == 'sticker') {
                        var var_image = variant.featured_image.src;
                        var bundle_image = $(evt.currentTarget).find(".bundle-item--image img");
                        var bundle_label = $(evt.currentTarget).find(".variant__label-info span");
                        if(bundle_image.length) {
                            bundle_image.attr("src", var_image);
                        }
                        if(bundle_label.length) {
                            bundle_label.text(variant.options[0]);    
                        }
                    }

                    setTimeout(function(){
                        var varSelector = $(evt.currentTarget).find('.product-single__variants');
                        var bottle = varSelector.find('option:selected').data("bottle");
                        var bottleMsg = $(evt.currentTarget).find('.bottle-msg');
                        if(bottle) {
                          if(bottle > 1){
                            bottleMsg.text('Made with ' + bottle + ' recycled bottles').show();
                          }
                          else{
                            bottleMsg.text('Made with ' + bottle + ' recycled bottle').show();    
                          }
                        } else {
                            bottleMsg.hide();    
                        }

                    }, 50)
                }).bind(_this))

                if (theme.settings.dynamicVariantsEnable && currentVariantObject) {
                    
                    $(item).find(".variant-input > input")
                    .on('change' + '.bundle-variant-changed', _this.updateVariantAvailability2.bind(_this, variant.variants, item));
                    $(item).find(".variant-input > input")
                    .on('change' + '.bundle-variant-changed', _this.stripOutstock.bind(_this, variant.variants, $(item)));
                    // Set default state based on current selected variant
                    _this.setCurrentVariantAvailability2(currentVariantObject, variant.variants, item);
                    // Strip outstock at load
                    _this.stripOutstockAtLoad(currentVariantObject, $(item));
                }
            })

            // Disable cart at first
            if(disableCart) {
                _this.$formContainer.find(_this.selectors.addToCart).addClass("disabled init-btn").prop("disabled", true);
                // $(ARNCUSTOM.selectors.addToCart).addClass("disabled init-btn").prop("disabled", true);
            }
        }
        
    }
    /**
     * FUNCTION TO STRIP OUT OPTION OUT OF STOCK AT PAGELOAD FIRST
     */
    stripOutstockAtLoad(currentVariant, container) {
        var optionLength = currentVariant.options.length;
        var prodId = '';

        if(container.attr('class').indexOf('bundle-item') != -1 || container.attr('class').indexOf('sticker-item') != -1) {
            prodId =  container.data('product-id');
        } else {
            prodId =  container.data('section-id'); // old theme is 'section-id' (product id), new theme is 'product-id'
        }
        var variantObject = prodId ? JSON.parse(container.find("#VariantsJson-" + prodId)[0].innerHTML) : [];
        
        // Extract variant items that need to check
        var checkVariants = [];
        for(var i = 0; i < variantObject.length; i++) {
            var flag = true;
            for (var j = optionLength - 1; j >= 1; j--) {
                if(currentVariant['option' + j] != variantObject[i]['option' + j]) {
                    flag = false;
                    break;
                }
            }
            if(flag) {
                checkVariants.push(variantObject[i]);    
            }
        }
        
        // Get last options list with visible item
        var handleOptions = [];
        var variant_list = container.find('.variant-input');
        variant_list.each(function(index, item) {
            if($(item).data('index') == 'option' + optionLength) {
                var label = $(item).find('label');
                if(label.is(':visible')) {
                    handleOptions.push(item);    
                }
            }
        });

        // Add Class strip out based on extract variant
        for(var i = 0; i < checkVariants.length; i++) {
            for(var j = 0; j < handleOptions.length; j++) {
                var dataValue = $(handleOptions[j]).data('value');
                var optionValue = checkVariants[i]['option' +  optionLength];
                let inputEl = $(handleOptions[j]).find('input');
                if(dataValue == optionValue && !checkVariants[i].available) {
                    $(handleOptions[j]).addClass('strip-out');
                    inputEl.removeClass('data-available'); // 10/02/2024
                } 
                if(dataValue == optionValue && checkVariants[i].available) {
                    inputEl.addClass('data-available'); // 10/02/2024
                }
            }
        }
    }

    /**
     * FUNCTION TO STRIP OUT OPTIONS OUT OF STOCK WHEN INPUT SELECTED
     */
    stripOutstock() {
        var variantObject = arguments[0];
        var container = arguments[1];
        var evt = arguments[2];
        var optionLength = variantObject[0].options.length;

        // Click on last options list return, mean click option 2
        if($(evt.currentTarget).data('index') == 'option' + optionLength) return;
        else {
            $(evt.currentTarget).addClass('data-available');
        }
        // Remove all strip-out first
        container.find('.variant-wrapper .variant-input.strip-out').removeClass('strip-out')
        container.find('.variant-wrapper .variant-input.strip-out > input').removeClass('data-available')

        // Get all checked input except option Length position
        var selectedOptions = [];
        container.find('.variant-wrapper .variant-input > input').each(function(index, item) {
            if($(item).is(':checked') && $(item).data('index') != 'option' + optionLength) {
                selectedOptions.push($(item).val());
            }
        });
        
        // Extract variant items that need to check
        var checkVariants = [];
        for(var i = 0; i < variantObject.length; i++) {
            var flag = true;
            for (var j = 1; j <= optionLength - 1; j++) {
                if(selectedOptions[j - 1] != variantObject[i]['option' + j]) {
                    flag = false;
                    break;
                }
            }
            if(flag) {
                checkVariants.push(variantObject[i]);    
            }
        }

        // Add Class strip out based on extract variant
        for(var i = 0; i < checkVariants.length; i++) {
            container.find('.variant-wrapper .variant-input > input').each(function(index, item) {
                if($(item).data('index') == 'option' + optionLength) {
                    var dataValue = $(item).val();
                    var optionValue = checkVariants[i]['option' +  optionLength];
                    if(dataValue == optionValue && !checkVariants[i].available) {
                        $(item).removeClass('data-available'); // 10/02/2024
                        $(item).parent().addClass('strip-out');
                    } 
                    if(dataValue == optionValue && checkVariants[i].available) {
                        $(item).addClass('data-available'); // 10/02/2024
                    }
                }
            })    
        }

    }
    initQtySelector() {
        this.$container.find('.js-qty__wrapper').each(function() {
            new theme.QtySelector($(this), {
                namespace: '.product'
            });
        });
    }

    initAjaxProductForm() {
        if (theme.settings.cartType === 'drawer') {
            new theme.AjaxProduct(this.$formContainer);
        }
    }

    /*============================================================================
      Dynamic variant availability
        - To disable, set dynamicVariantsEnable to false in theme.liquid
    ==============================================================================*/
    // SET CURRENT VARIANT FOR BUNDLE
    setCurrentVariantAvailability2(variant, variantList, container) {
        
        var valuesToEnable = {
            option1: [],
            option2: [],
            option3: []
        };

        // Disable all options to start
        this.disableVariantGroup($(container).find('.variant-input-wrap'));

        // Combine all available variants
        var availableVariants = variantList.filter(function(el) {
            if (variant.id === el.id) {
                return false;
            }

            // Option 1
            if (variant.option2 === el.option2 && variant.option3 === el.option3) {
                return true;
            }

            // Option 2
            if (variant.option1 === el.option1 && variant.option3 === el.option3) {
                return true;
            }

            // Option 3
            if (variant.option1 === el.option1 && variant.option2 === el.option2) {
                return true;
            }
        });

        // IE11 can't handle shortform of {variant} so extra step is needed
        var variantObject = {
            variant: variant
        };

        availableVariants = Object.assign({}, variantObject, availableVariants);

        // Loop through each available variant to gather variant values
        for (var property in availableVariants) {
            if (availableVariants.hasOwnProperty(property)) {
                var item = availableVariants[property];
                var option1 = item.option1;
                var option2 = item.option2;
                var option3 = item.option3;

                if (option1) {
                    if (valuesToEnable.option1.indexOf(option1) === -1) {
                        valuesToEnable.option1.push(option1);
                    }
                }
                if (option2) {
                    if (valuesToEnable.option2.indexOf(option2) === -1) {
                        valuesToEnable.option2.push(option2);
                    }
                }
                if (option3) {
                    if (valuesToEnable.option3.indexOf(option3) === -1) {
                        valuesToEnable.option3.push(option3);
                    }
                }
            }
        }

        // Have values to enable, separated by option index
        if (valuesToEnable.option1.length) {
            this.enableVariantOptionByValue(valuesToEnable.option1, 'option1', container);
        }
        if (valuesToEnable.option2.length) {
            this.enableVariantOptionByValue(valuesToEnable.option2, 'option2', container);
        }
        if (valuesToEnable.option3.length) {
            this.enableVariantOptionByValue(valuesToEnable.option3, 'option3', container);
        }
    }

    setCurrentVariantAvailability(variant) {
        var valuesToEnable = {
            option1: [],
            option2: [],
            option3: []
        };

        // Disable all options to start
        this.disableVariantGroup($(this.selectors.formContainer).find('.variant-input-wrap'));

        // Combine all available variants
        var availableVariants = this.variantsObject.filter(function(el) {
            if (variant.id === el.id) {
                return false;
            }

            // Option 1
            if (variant.option2 === el.option2 && variant.option3 === el.option3) {
                return true;
            }

            // Option 2
            if (variant.option1 === el.option1 && variant.option3 === el.option3) {
                return true;
            }

            // Option 3
            if (variant.option1 === el.option1 && variant.option2 === el.option2) {
                return true;
            }
        });


        // IE11 can't handle shortform of {variant} so extra step is needed
        var variantObject = {
            variant: variant
        };

        availableVariants = Object.assign({}, variantObject, availableVariants);

        // Loop through each available variant to gather variant values
        for (var property in availableVariants) {
            if (availableVariants.hasOwnProperty(property)) {
                var item = availableVariants[property];
                var option1 = item.option1;
                var option2 = item.option2;
                var option3 = item.option3;

                if (option1) {
                    if (valuesToEnable.option1.indexOf(option1) === -1) {
                        valuesToEnable.option1.push(option1);
                    }
                }
                if (option2) {
                    if (valuesToEnable.option2.indexOf(option2) === -1) {
                        valuesToEnable.option2.push(option2);
                    }
                }
                if (option3) {
                    if (valuesToEnable.option3.indexOf(option3) === -1) {
                        valuesToEnable.option3.push(option3);
                    }
                }
            }
        }

        // Have values to enable, separated by option index
        if (valuesToEnable.option1.length) {
            this.enableVariantOptionByValue(valuesToEnable.option1, 'option1');
        }
        if (valuesToEnable.option2.length) {
            this.enableVariantOptionByValue(valuesToEnable.option2, 'option2');
        }
        if (valuesToEnable.option3.length) {
            this.enableVariantOptionByValue(valuesToEnable.option3, 'option3');
        }
    }

    // UPDATE VARIANT FOR BUNDLE
    updateVariantAvailability2(variantList, container, evt, value, index){
        
        if (value && index) {
            var newVal = value;
            var optionIndex = index;
        } else {
            var $el = $(evt.currentTarget);
            var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
            var optionIndex = $el.data('index');
        }
        
        var variants = variantList.filter(function(el) {
            return el[optionIndex] === newVal;
        });

        // Disable all buttons/dropdown options that aren't the current index
        $(container).find('.variant-input-wrap').each(function(index, el) {
            var $group = $(el);
            var currentOptionIndex = $group.data('index');

            if (currentOptionIndex !== optionIndex) {
                // Disable all options as a starting point
                this.disableVariantGroup($group);

                // Loop through legit available options and enable
                for (var i = 0; i < variants.length; i++) {
                    this.enableVariantOption($group, variants[i][currentOptionIndex]);
                }
            }
        }.bind(this));
    }

    updateVariantAvailability(evt, value, index) {

        if (value && index) {
            var newVal = value;
            var optionIndex = index;
        } else {
            var $el = $(evt.currentTarget);
            var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
            var optionIndex = $el.data('index');
        }
        
        var variants = this.variantsObject.filter(function(el) {
            return el[optionIndex] === newVal;
        });

        // Disable all buttons/dropdown options that aren't the current index
        $(this.selectors.formContainer).find('.variant-input-wrap').each(function(index, el) {
            var $group = $(el);
            var currentOptionIndex = $group.data('index');

            if (currentOptionIndex !== optionIndex) {
                // Disable all options as a starting point
                this.disableVariantGroup($group);

                // Loop through legit available options and enable
                for (var i = 0; i < variants.length; i++) {
                    this.enableVariantOption($group, variants[i][currentOptionIndex]);
                }
            }
        }.bind(this));
    }

    // Thanh 23/06/2021
    checkTypeBottom(group, typeCheck){
        let check = false;                              
        let parent = group.closest('.bundle-item');
        if(parent) // Top or bottom, need more check
        {
            var bundelImageTagA = parent.find('.bundle-item--image > a').first();
            if (bundelImageTagA.length > 0)
            {
                if (bundelImageTagA.attr('href').toLowerCase().indexOf('tops') != -1)
                {
                    check = typeCheck == 'tops' ? true : false;
                } 
                else if (bundelImageTagA.attr('href').toLowerCase().indexOf('bottoms') != -1)
                {                            
                    check = typeCheck == 'bottoms' ? true : false;
                    var fieldset = parent.find('fieldset.variant-input-wrap').first();                                
                    if (fieldset.length > 0) { fieldset.addClass('arn-variant-type-bottoms'); }
                }
            }
        }                
        return check;
    }

    disableVariantGroup($group) {
        this.checkTypeBottom($group, 'bottoms');
        if (theme.settings.dynamicVariantType === 'dropdown') {
            $group.find('option').prop('disabled', true)
        } else {    
            $group.each(function(index, group) {
                var groupName = $(group).attr("name");
                // DO NOT DISABLE BOTTOM TYPE OPTION
                if(groupName !== 'BOTTOM TYPE' && groupName !== 'STYLE'  && !$(group).hasClass('arn-variant-type-bottoms')) {
                  if(groupName !== 'TYPE DE BAS' && groupName !== 'STYLE' && !$(group).hasClass('arn-variant-type-bottoms')){
                    $(group).find('input').prop('disabled', true);
                    $(group).find('label').toggleClass('disabled', true).addClass('unavailable');
                  }
                }
            })
            
        }
    }

    enableVariantOptionByValue(array, index, container) {
        container = typeof container !== 'undefined' ? container : null;
        var $group;
        if(container == null) {
            $group = $(this.selectors.formContainer).find('.variant-input-wrap[data-index="' + index + '"]');
        } else {
            $group = $(container).find('.variant-input-wrap[data-index="' + index + '"]');   
        }
        

        for (var i = 0; i < array.length; i++) {
            this.enableVariantOption($group, array[i]);
        }
    }

    enableVariantOption($group, value) {
        // Selecting by value so escape it
        value = value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');

        if (theme.settings.dynamicVariantType === 'dropdown') {
            $group.find('option[value="' + value + '"]').prop('disabled', false);
        } else {
            var $buttonGroup = $group.find('.variant-input[data-value="' + value + '"]');
            $buttonGroup.find('input').prop('disabled', false);
            $buttonGroup.find('label').toggleClass('disabled', false).removeClass('unavailable');
        }
    }

    /*============================================================================
      Variant change methods
    ==============================================================================*/
    updateColorName(color, index) {
        // Updates on radio button change, not variant.js
        $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
    }

    checkOtherBundleStatus(container, variant) {
        let productCount = container.find('.group-product-count').length ? container.find('.group-product-count').val() : 1;
        var returnVal = [];
        var checkedBundleItemCount = 0;
        var unavailableToAddCartCount = 0;
        container.find('.bundle-item').each(function(index, item) {
            if(true) {
                $(item).find('.variant-input > input').each(function(){
                    let inputEl = $(this)
                    if($(this).is(":checked")) {
                        let dataProductAvailabel = inputEl.hasClass('data-available')
                        if(!dataProductAvailabel) {
                            returnVal.push('soldout'); 
                            ++unavailableToAddCartCount;
                        } else {

                        }
                        if(!$(this).parent().find("label").is(":visible")) {
                            returnVal.push('unavailable'); 
                            ++unavailableToAddCartCount;
                        }
                        ++checkedBundleItemCount;
                    }
                })
                $(item).find('.product-single__variants').each(function(){
                    if(!this.value || this.value == 'none') {
                        // Other product soldout
                        if(!this.value) {
                            returnVal.push('soldout');
                            ++unavailableToAddCartCount;
                        } else {
                            returnVal.push('none');
                            ++unavailableToAddCartCount;
                        }
                    }    
                })
                
            }
        });
        let validCheckedCount = checkedBundleItemCount - unavailableToAddCartCount
        //console.log(returnVal)
        if(validCheckedCount > 0 && productCount != validCheckedCount) {
            return 'Choose All Options';
        } if(validCheckedCount === 0 ) {
            return 'none';
        } else if(returnVal.indexOf('none') != -1) 
            return 'none';
        else if(returnVal.indexOf('unavailable') != -1)
            return theme.strings.unavailable;
        else if(returnVal.indexOf('soldout') != -1)
            return theme.strings.soldOut;
        else    
            return '';
    }

    updateCartButton(evt) {
        var outstockMsg = $(evt.currentTarget).find(".outstock-msg");
        var variant = evt.variant;
        var _this = this;

        // Single product
        if(!_this.$formContainer.find('.group-product').length) {
            // Remove init btn state immediatly
            // $(ARNCUSTOM.selectors.addToCartInTemplate).removeClass('init-btn');
            let addToCartEls = _this.$formContainer.find(_this.selectors.addToCart)
            let addToCartTextEls = _this.$formContainer.find(_this.selectors.addToCartText)
            addToCartEls.removeClass('init-btn');
            if(variant) {
                if(variant.available) {
                    addToCartEls.removeClass(_this.classes.disabled).prop('disabled', false);
                    addToCartTextEls.html(theme.strings.addToCart);
                } else {
                    addToCartEls.addClass(_this.classes.disabled).prop('disabled', true);
                    addToCartTextEls.html(theme.strings.soldOut);
                }
            }
            else {
                $(this.selectors.addToCart).addClass(_this.classes.disabled).prop('disabled', true);
                $(this.selectors.addToCartText).html(theme.strings.unavailable);
            }
        }
        // Bundle Product
        else {
            var container = $(evt.currentTarget);
            var status = '';
            if(variant) {
                setTimeout(function(){
                    status = _this.checkOtherBundleStatus(_this.$formContainer, variant);
                    
                    if(variant.available) {
                        // Hide out of stock
                        outstockMsg.toggleClass('show', false);    
                    } else {
                        // Show out of stock
                        outstockMsg.text(variant.title + ': is out of stock').toggleClass('show', true);
                    }
                    if(status == '') {
                        // Remove init btn state immediatly
                        // $(ARNCUSTOM.selectors.addToCartInTemplate).removeClass('init-btn');
                        // $(_this.selectors.addToCart).removeClass(_this.classes.disabled).prop('disabled', false);
                        // $(_this.selectors.addToCartText).html(theme.strings.addToCart);
                        let addToCartEls = $(_this.selectors.formContainer).find(_this.selectors.addToCart)
                        let addToCartTextEls = $(_this.selectors.formContainer).find(_this.selectors.addToCartText)

                        addToCartEls.removeClass('init-btn');
                        addToCartEls.removeClass(_this.classes.disabled).prop('disabled', false);
                        addToCartTextEls.html(theme.strings.addToCart);
                            
                    } else {
                        $(_this.selectors.addToCart).addClass(_this.classes.disabled).prop('disabled', true);     
                        if(status != 'none') {
                            // Remove init btn state immediatly
                            $(ARNCUSTOM.selectors.addToCart).removeClass('init-btn');
                            $(_this.selectors.addToCartText).html(status);
                        }
                    }
                },50)
                
                
            } else {
                // Hide out of stock msg
                outstockMsg.toggleClass('show', false);
                setTimeout(function(){
                    status = _this.checkOtherBundleStatus(_this.$formContainer);  
                    
                    if(status == '') {
                        // Remove init btn state immediatly
                        $(ARNCUSTOM.selectors.addToCart).removeClass('init-btn');
                        $(_this.selectors.addToCart).removeClass(_this.classes.disabled).prop('disabled', false);
                        $(_this.selectors.addToCartText).html(theme.strings.addToCart);
                            
                    } else {
                        $(_this.selectors.addToCart).addClass(_this.classes.disabled).prop('disabled', true);     
                        if(status != 'none') {
                            // Remove init btn state immediatly
                            $(ARNCUSTOM.selectors.addToCart).removeClass('init-btn');
                            $(_this.selectors.addToCartText).html(status);
                        }
                    }
                },50)
            }
        }
    }

    updateMainPrice() {
        var padJson = {}, stickerJson = {}, productJson = {};
        var padPrice, stickerPrice, productPrice;

        productJson = JSON.parse($("#VariantsJson-" + this.id)[0].innerHTML);

        // Get main selected variant
        var selectedProductId = $("#ProductSelect-" + this.id).val();
        for(var j = 0; j < productJson.length; j++) {
            var productId = productJson[j].id.toString();
            if(productId == selectedProductId) {
                productPrice = productJson[j].price; 
            }     
        }

        // If pad option exists
        if($(".pad-variant-json").length) {
            padJson = JSON.parse($(".pad-variant-json")[0].innerHTML);
            padPrice = padJson[0].price;
            if($("#buy-with-pad").is(":checked")) {
                productPrice += padPrice;   
            }
        }

        // If sticker exists
        if($(".sticker-variant-json").length) {
            stickerJson = JSON.parse($(".sticker-variant-json")[0].innerHTML);
            // Get selected sticker variant
            var selectedStickerId = $('.sticker-item .product-single__variants').val();
            for(var i = 0; i < stickerJson.length; i++) {
                var stickerId = stickerJson[i].id.toString();
                if(stickerId == selectedStickerId) {
                    stickerPrice = stickerJson[i].price; 
                }
            }
            if(stickerPrice) {
                productPrice += stickerPrice;       
            }
        }
        
        
        $('#ProductPrice-' + this.id).html(theme.Currency.formatMoney(productPrice, theme.settings.moneyFormat));
        
    }

    // UPDATE PRICE FOR BUNDLE
    updatePrice2(prodId, container, evt) {
        var variant = evt.variant;
        var _this = this;
        
        // Sticker Item update main price when bundle
        if(container.className.indexOf("sticker-item") !== -1) {
            this.updateMainPrice();
        }

        if (variant) {
            // Regular price
            $(container).find('#ProductPrice-' + prodId).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();
            
            // Sale price, if necessary
            if (variant.compare_at_price > variant.price) {
                $(container).find('#ComparePrice-' + prodId).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
                $(container).find('.product__price-wrap-' + prodId).removeClass('hide');
                $(container).find('#ProductPrice-' + prodId).addClass(_this.classes.onSale);
                $(container).find('#ComparePriceA11y-' + prodId).attr('aria-hidden', 'false');
                $(container).find('#PriceA11y-' + prodId).attr('aria-hidden', 'false');

                var savings = variant.compare_at_price - variant.price;

                if (theme.settings.saveType == 'percent') {
                    savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
                } else {
                    savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
                }

                $(container).find('#SavePrice-' + prodId)
                    .removeClass('hide')
                    .html(theme.strings.savePrice.replace('[saved_amount]', savings));
            } else {
                $(container).find('.product__price-wrap-' + prodId).addClass('hide');
                $(container).find('#ProductPrice-' + prodId).removeClass(_this.classes.onSale);
                $(container).find('#ComparePriceA11y-' + prodId).attr('aria-hidden', 'true');
                $(container).find('#PriceA11y-' + prodId).attr('aria-hidden', 'true');
                $(container).find('#SavePrice-' + prodId).addClass('hide')
            }
        }
    }

    updatePrice(evt) {
        var _this = this;
        var variant = evt.variant;
        if (variant) {
            // Regular price
            $(this.selectors.price).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();

            // Sale price, if necessary
            if (variant.compare_at_price > variant.price) {
                $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
                $(this.selectors.priceWrapper).removeClass('hide');
                $(this.selectors.price).addClass(_this.classes.onSale);
                $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
                $(this.selectors.priceA11y).attr('aria-hidden', 'false');

                var savings = variant.compare_at_price - variant.price;

                if (theme.settings.saveType == 'percent') {
                    savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
                } else {
                    savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
                }

                $(this.selectors.savePrice)
                    .removeClass('hide')
                    .html(theme.strings.savePrice.replace('[saved_amount]', savings));
            } else {
                $(this.selectors.priceWrapper).addClass('hide');
                $(this.selectors.price).removeClass(_this.classes.onSale);
                $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
                $(this.selectors.priceA11y).attr('aria-hidden', 'true');
                $(this.selectors.savePrice).addClass('hide')
            }
        }
    }

    updateUnitPrice(evt) {
        var variant = evt.variant;

        if (variant && variant.unit_price) {
            $(this.selectors.unitPrice).html(theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat));
            $(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(variant));
            $(this.selectors.unitWrapper).removeClass('hide').removeClass(_this.classes.visuallyHide);
        } else {
            $(this.selectors.unitWrapper).addClass(_this.classes.visuallyHide);
        }
    }

    updateSku(evt) {
        var variant = evt.variant;
        var newSku = '';

        if (variant) {
            if (variant.sku) {
                newSku = variant.sku;
            }

            $(this.selectors.sku).html(newSku);
        }
    }

    updateInventory(evt) {
        var variant = evt.variant;

    // Hide stock if no inventory management or policy is continue
    if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
            this.toggleInventoryQuantity(false);
            this.toggleIncomingInventory(false);
            return;
        }

        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.sectionId]) {
            variantInventoryObject = window.inventories[this.sectionId][variant.id];
            var quantity = variantInventoryObject.quantity;
            var showInventory = true;
            var showIncomingInventory = false;

            if (quantity <= 0 || quantity > theme.settings.inventoryThreshold) {
                showInventory = false;
            }

            this.toggleInventoryQuantity(showInventory, quantity);

            if (!showInventory && variantInventoryObject.incoming) {
                showIncomingInventory = true;
            }

            this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
    }

    toggleInventoryQuantity(show, qty) {
        if (!this.settings.inventory) {
            show = false;
        }

        if (show) {
            $(this.selectors.inventory)
                .removeClass('hide')
                .text(theme.strings.stockLabel.replace('[count]', qty));
        } else {
            $(this.selectors.inventory).addClass('hide');
        }
    }

    toggleIncomingInventory(show, available, date) {
        if (!this.settings.incomingInventory) {
            show = false;
        }

        if (show) {
            var string = available ?
                theme.strings.willNotShipUntil.replace('[date]', date) :
                theme.strings.willBeInStockAfter.replace('[date]', date);

            if (!date) {
                string = theme.strings.waitingForStock;
            }

            $(this.selectors.incomingInventory)
                .removeClass('hide')
                .text(string);
        } else {
            $(this.selectors.incomingInventory).addClass('hide');
        }
    }

    /*============================================================================
        Product videos
    ==============================================================================*/
    checkIfVideos() {
        var $productVideos = this.$mainSlider.find(selectors.productVideo);

        // Stop if there are 0 videos
        if (!$productVideos.length) {
            return false;
        }

        var videoTypes = [];

        $productVideos.each(function() {
            var type = $(this).data('video-type');

            if (videoTypes.indexOf(type) < 0) {
                videoTypes.push(type);
            }
        });

        // Load YouTube API if not already loaded
        if (videoTypes.indexOf('youtube') > -1) {
            if (!theme.config.youTubeReady) {
                theme.LibraryLoader.load('youtubeSdk');
                $('body').on('youTubeReady' + this.settings.namespace, function() {
                    this.loadYoutubeVideos($productVideos);
                }.bind(this));
            } else {
                this.loadYoutubeVideos($productVideos);
            }
        }

        // Add mp4 video players
        if (videoTypes.indexOf('mp4') > -1) {
            this.loadMp4Videos($productVideos);
        }

        return videoTypes;
    }

    loadMp4Videos($videos) {
        $videos.each(function() {
            var $el = $(this);
            if ($el.data('video-type') != 'mp4') {
                return;
            }

            var id = $el.attr('id');
            var videoId = $el.data('video-id');

            videos[id] = {
                type: 'mp4',
                divId: id,
                style: $el.data('video-style')
            };
        });
    }

    loadYoutubeVideos($videos) {
        $videos.each(function() {
            var $el = $(this);
            if ($el.data('video-type') != 'youtube') {
                return;
            }

            var id = $el.attr('id');
            var videoId = $el.data('youtube-id');

            videos[id] = {
                type: 'youtube',
                id: id,
                videoId: videoId,
                style: $el.data('video-style'),
                loop: $el.data('video-loop'),
                attemptedToPlay: false,
                events: {
                    onReady: function(evt) {
                        onVideoPlayerReady(evt, id);
                    },
                    onStateChange: function(evt) {
                        onVideoStateChange(evt, id);
                    }
                }
            };
        });

        // Create a player for each YouTube video
        for (var key in videos) {
            if (videos[key].type === 'youtube') {
                if (videos.hasOwnProperty(key)) {
                    var args = $.extend({}, youtubeVideoOptions, videos[key]);

                    if (args.style === 'muted') {
                        // default youtubeVideoOptions, no need to change anything
                    } else {
                        args.playerVars.controls = 1;
                        args.playerVars.autoplay = 0;
                    }

                    youtubePlayers[key] = new YT.Player(key, args);
                }
            }
        }

        youtubeReady = true;
    }

    initVideo($video) {
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');

        if (videoType === 'mp4' && videos[divId].style === 'muted') {
            this.playMp4Video(divId);
        }

        if (videoType === 'youtube') {
            if (youtubeReady && videos[divId].style === 'muted') {
                this.requestToPlayYoutubeVideo(divId);
            }
        }

        // Hacky way to trigger resetting the slider layout in modals
        if (this.inModal) {
            this.resizeSlides();
        }
    }

    stopVideo(id, type) {
        if (!id) {
            this.stopYoutubeVideo();
            this.stopMp4Video();
        }

        if (type === 'youtube') {
            this.stopYoutubeVideo(id);
        }

        if (type === 'mp4') {
            this.stopMp4Video(id);
        }
    }

    // Thanh copy func từ v4.1.1 27/04/2021
    stopVideos() {
        for (var [id, vid] of Object.entries(videoObjects)) {
            if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
                vid.videoPlayer.stopVideo(); // YouTube player
            }
            } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
            }
        }
    }

    getVideoType($video) {
        return $video.data('video-type');
    }

    getVideoId($video) {
        return $video.attr('id');
    }

    // Sub video functions (MP4 and YouTube)
    requestToPlayYoutubeVideo(id, forcePlay) {
        if (!theme.config.youTubeReady) {
            return;
        }

        var $player = $('#' + id);
        setParentAsLoading($player);

        // If video is requested too soon, player might not be ready.
        // Set arbitrary timeout to request it again in a second
        if (typeof youtubePlayers[id].playVideo != 'function') {
            setTimeout(function() {
                this.playYoutubeVideo(id, forcePlay);
            }.bind(this), 1000);
            return;
        }

        this.playYoutubeVideo(id, forcePlay);
    }

    playYoutubeVideo(id, forcePlay) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        if (typeof youtubePlayers[id].playVideo === 'function') {
            youtubePlayers[id].playVideo();
        }

        // forcePlay is sent as true from beforeSlideChange so the visibility
        // check isn't fooled by the next slide positioning
        if (!forcePlay) {
            initCheckVisibility(id);
        }
    }

    stopYoutubeVideo(id) {
        if (!theme.config.youTubeReady) {
            return;
        }

        if (id && youtubePlayers[id]) {
            if (typeof youtubePlayers[id].pauseVideo === 'function') {
                youtubePlayers[id].pauseVideo();
            }
            $(window).off('scroll.' + id);
        } else {
            for (key in youtubePlayers) {
                var childVideo = this.$container.find('#' + key);
                if (childVideo.length && typeof youtubePlayers[key].pauseVideo === 'function') {
                    youtubePlayers[key].pauseVideo();
                    $(window).off('scroll.' + key);
                }
            }
        }
    }

    playMp4Video(id) {
        var $player = $('#' + id);
        setParentAsLoaded($player);

        var playPromise = $player[0].play();

        if (playPromise !== undefined) {
            playPromise.then(function() {})
                .catch(function(error) {
                    // Likely low power mode on iOS, show controls
                    $player[0].setAttribute('controls', '');
                    $player.closest(selectors.videoParent).attr('data-video-style', 'unmuted');
                });
        }
    }

    stopMp4Video(id) {
        if (id) {
            $('#' + id)[0].pause();
        } else {
            // loop through all mp4 videos to stop them
            for (var key in videos) {
                var childVideo = this.$container.find('#' + key);
                if (childVideo.length && videos[key].type === 'mp4') {
                    var player = $('#' + videos[key].divId)[0];
                    if (player && typeof player.pause === 'function') {
                        player.pause();
                    }
                }
            }
        }
    }

            /*============================================================================
              Product images
            ==============================================================================*/
            initImageZoom() {
                var $container = $(this.selectors.imageContainer, this.$container);
                var imageZoom = new theme.Photoswipe($container[0], this.sectionId);
            }

            setImageSizes() {
                if (!this.settings.hasImages) {
                    return;
                }

                // Get srcset image src, works on most modern browsers
                // otherwise defaults to settings.imageSize
                var currentImage = this.$firstProductImage[0].currentSrc;

                if (currentImage) {
                    this.settings.imageSize = theme.Images.imageSize(currentImage);
                }
            }

            updateVariantImage(evt) {
                var variant = evt.variant;
                var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
                var $newImage = $('.product__thumb[data-id="' + variant.featured_media.id + '"]');
                var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

                // No image, bail
                if (typeof imageIndex === 'undefined') {
                    return;
                }

                this.$mainSlider.slick('slickGoTo', imageIndex);
            }

            initImageSwitch() {
                if (!$(this.selectors.photoThumbs).length) {
                    return;
                }

                $(this.selectors.photoThumbs)
                    .on('click', function(evt) {
                        evt.preventDefault();
                    })
                    .on('focus', function(evt) {
            if (!this.settings.slickThumbInitialized) { return }
                        var index = $(evt.currentTarget).data('index');
                        if (index !== undefined) {
                            this.$thumbSlider.slick('slickGoTo', index);
                        }
                    }.bind(this))
                    .on('keydown', function(evt) {
                        if (evt.keyCode === 13) {
                            this.$container.find(selectors.currentSlide).focus();
                        }
                    }.bind(this));
            }

            createImageCarousels() {
                if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
                    // Single product image. Init video if it exists
                    var $video = $(this.selectors.productImageMain).find(selectors.productVideo);
                    if ($video.length) {
                        this.initVideo($video);
                    }
                    return;
                }

                this.settings.hasMultipleImages = true;
                this.settings.has3d = this.$container.find(this.selectors.media).length;

                // Set starting slide (for both sliders)
                var $activeSlide = this.$mainSlider.find('.starting-slide');
                var startIndex = this._slideIndex($activeSlide);

                // Lame way to prevent duplicate event listeners
                this.$mainSlider.off('init');
                this.$mainSlider.off('beforeChange');
                this.$mainSlider.on('init', this.mainSlideInit.bind(this));
                this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
                this.$thumbSlider.on('init', this.thumbSlideInit.bind(this));

                // Default (mobile) slider settings
                this.mainSliderArgs = {
                    infinite: this.settings.has3d ? false : true,
                    arrows: false,
                    dots: true,
                    adaptiveHeight: true,
                    initialSlide: startIndex,
                    appendDots: this.selectors.dotsContainer
                };

                this.thumbSliderArgs = {
                    accessibility: false,
                    initialSlide: startIndex
                };

                // Init sliders normally
                var sliderArgs = this.setSliderArgs();
                this.initSliders(sliderArgs);

                // Re-init slider when a breakpoint is hit
                $('body').on('matchSmall matchLarge', function() {
                    var sliderArgs = this.setSliderArgs();
                    this.initSliders(sliderArgs);
                }.bind(this));

                // Too many thumbnails can cause the AOS calculations to be off
                // so refresh that when the slider is ready
                if (AOS) {
                    AOS.refresh();
                }
            }

            initSliders(args) {
                this.destroyImageCarousels();
                this.$mainSlider.slick(args.main);
                if (!theme.config.bpSmall) {
                    this.$thumbSlider.slick(args.thumbs);
                }

                this.settings.slickMainInitialized = true;
            }

            setSliderArgs() {
                var args = {};

                var thumbnailsVertical = this.settings.thumbVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;
                var thumbArrows = this.settings.thumbArrows = this.$thumbSlider.data('arrows');

                var slidesToShow = thumbnailsVertical && thumbArrows ? 1 :
                    (thumbnailsVertical ? 3 : 5);

                if (theme.config.bpSmall) {
                    args.main = this.mainSliderArgs;
                    args.thumbs = this.thumbSliderArgs;
                } else {
                    args.main = $.extend({}, this.mainSliderArgs, {
                        asNavFor: this.selectors.thumbSlider,
                        adaptiveHeight: thumbnailsVertical ? false : true,
                        dots: false,
                        infinite: false,
                        fade: true
                    });
                    args.thumbs = $.extend({}, this.thumbSliderArgs, {
                        asNavFor: this.selectors.mainSlider,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: thumbArrows,
                        dots: false,
                        vertical: thumbnailsVertical,
                        verticalSwiping: thumbnailsVertical,
                        focusOnSelect: true,
                        infinite: false,
                        customHeightMatching: thumbArrows ? false : thumbnailsVertical,
                        customSlideAdvancement: true
                    });
                }

                return args;
            }

            destroyImageCarousels() {
                if (this.$mainSlider && this.settings.slickMainInitialized) {
                    this.$mainSlider.slick('unslick');
                    this.settings.slickMainInitialized = false;
                }

                if (this.$thumbSlider && this.settings.slickThumbInitialized) {
                    this.$thumbSlider.slick('unslick');
                    this.settings.slickThumbInitialized = false;
                }

                this.settings.slickMainInitialized = false;
                this.settings.slickThumbInitialized = false;
            }

            mainSlideInit(event, slick) {
                var $slider = slick.$slider;
                var $currentSlide = $slider.find(selectors.currentSlide);
                var $video = $currentSlide.find(selectors.productVideo);

                if (!$video.length) {
                    return;
                }

                this.initVideo($video);
            }

            thumbSlideInit(event, slick) {
                this.settings.slickThumbInitialized = true;

                // Check if we need to hide the arrows
                if (this.settings.thumbArrows) {
                    this.$thumbSlider.on('setPosition', this.thumbSlideArrowVisibility.bind(this));
                }
            }

            thumbSlideArrowVisibility(event, slick) {
                var $slider = slick.$slider;
                var $arrows = $slider.find('.slick-arrow');
                var showArrows = false;

                if (this.settings.thumbVertical) {
                    var $trackHeight = $slider.find('.slick-track').height();
                    if ($trackHeight >= $slider.height()) {
                        showArrows = true;
                    }
                } else {
                    var $trackWidth = $slider.find('.slick-track').width();
                    if ($trackWidth >= $slider.width()) {
                        showArrows = true;
                    }
                }

                if (showArrows) {
                    $arrows.removeClass('hide');
                } else {
                    $arrows.addClass('hide');
                }
            }

            beforeSlideChange(event, slick, currentSlide, nextSlide) {
                var $slider = slick.$slider;
                var $currentSlide = $slider.find(selectors.currentSlide);
                var $prevVideo = $currentSlide.find('.product__video');
                var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
                var $nextVideo = $nextSlide.find('.product__video');

                // Pause any existing slide video
                if (currentSlide !== nextSlide && $prevVideo.length) {
                    var prevVideoType = this.getVideoType($prevVideo);
                    var prevVideoId = this.getVideoId($prevVideo);

                    if (prevVideoId) {
                        this.stopVideo(prevVideoId, prevVideoType);
                    }
                }

                // Prep next slide video
                if ($nextVideo.length) {
                    var nextVideoType = this.getVideoType($nextVideo);
                    var nextVideoId = this.getVideoId($nextVideo);

                    // Prep YouTube with a backup in case API isn't ready
                    if (nextVideoId && nextVideoType === 'youtube') {
                        if (youtubeReady) {
                            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                                this.requestToPlayYoutubeVideo(nextVideoId, true);
                            }
                        } else {
                            $('body').on('youTubeReady' + this.settings.namespace, function() {
                                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                                    this.requestToPlayYoutubeVideo(nextVideoId, true);
                                }
                            }.bind(this))
                        }
                    }

                    // Autoplay muted MP4 videos
                    if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                        if (nextVideoType === 'mp4') {
                            this.playMp4Video(nextVideoId);
                        }
                    }

                    // Set unmuted videos to loaded state
                    if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
                        setParentAsLoaded($('#' + nextVideoId));
                    }
                }

                // Pause any existing media
                var $currentMedia = $currentSlide.find(this.selectors.media);
                if ($currentMedia.length) {
                    $currentMedia.trigger('mediaHidden');
                }

                // Prep next slide media
                var $nextMedia = $nextSlide.find(this.selectors.media);
                if ($nextMedia.length) {
                    $nextMedia.trigger('mediaVisible');
                    $nextSlide.find('.shopify-model-viewer-ui__button').attr('tabindex', 0);
                    $nextSlide.find('.product-single__close-media').attr('tabindex', 0);
                }
            }

            resizeSlides() {
                if (!this.settings.hasMultipleImages) {
                    return;
                }

                $(window).trigger('resize.slick');
                setTimeout(function() {
                    if (this.$mainSlider && this.settings.slickMainInitialized) {
                        this.$mainSlider.slick('setPosition');
                    }
                    if (this.$thumbSlider && this.settings.slickThumbInitialized) {
                        this.$thumbSlider.slick('setPosition');
                    }
                }.bind(this), 500); // same timing as modal open transition
            }

            _slideIndex($el) {
                return $el.data('index');
            }

    /*============================================================================
      Products when in quick view modal
    ==============================================================================*/
    // Thanh update 27/04/2021 from theme.js v4.1.1
    openModalProduct() {
        var initialized = false;

        if (!this.settings.modalInit) {
          var formHolder = this.container.querySelector(this.selectors.modalFormHolder);
          var url = formHolder.dataset.url;
          var template = formHolder.dataset.template;

          // Use stripped down ajax version for faster loading,
          // unless preorder template is used so we show right button
          if (template !== 'preorder') {
            url = url + '?view=ajax';
          }

          fetch(url).then(function(response) {
            return response.text();
          }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            this.cache.form = doc.querySelector('#AddToCartForm-' + this.sectionId + '-' + this.type_render);

            formHolder.innerHTML = '';
            formHolder.append(this.cache.form);
            formHolder.classList.add('product-form-holder--loaded');

            this.formSetup();

            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.sectionId
              }
            }));
          }.bind(this));
              
          // Setup product inventory data
          this.updateModalProductInventory();

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener('quickview:loaded', function(evt) {
                if (evt.detail.productId === this.sectionId) {
                  this.initProductSlider();
                }
              }.bind(this));
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        AOS.refreshHard();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.sectionId
          }
        }));
    }

    // Thanh giữ nguyên 27/04/2021
    closeModalProduct() {
        this.stopVideos();
        $('body').off(this.settings.namespace);
        $(window).off(this.settings.namespace);
    }

    loadModalContent() {
        // Load videos if they exist
        var videoTypes = this.checkIfVideos();

        // Lazyload mp4 videos
        if (videoTypes && videoTypes.indexOf('mp4') > -1) {
            this.$modal
                .find('.product__video[data-video-type="mp4"]')
                .find('.product__video-src')
                .each(function(i, video) {
                    var $el = $(video);
                    var src = $el.attr('src');
                    var type = $el.attr('type')
                    var newEl = document.createElement('source');
                    newEl.src = src;
                    newEl.type = type;
                    $el.after(newEl);
                }.bind(this));
        }
    }

    /*============================================================================
    Product images
    ==============================================================================*/
    initImageZoom() {
        var $container = $(this.selectors.imageContainer, this.$container);
        var imageZoom = new theme.Photoswipe($container[0], this.sectionId);
    }

    setImageSizes() {
        if (!this.settings.hasImages) {
            return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.$firstProductImage[0].currentSrc;

        if (currentImage) {
            this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
    }

    updateVariantImage(evt) {
        var variant = evt.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
        var $newImage = $('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

        // No image, bail
        if (typeof imageIndex === 'undefined') {
            return;
        }
        this.$mainSlider.slick('slickGoTo', imageIndex);
    }
};
function initCallerCustomization () {
    ARNCUSTOM.SetProductProduct = new ArnSetProduct('product')
    ARNCUSTOM.SetProductProduct.init()
    document.addEventListener('quick-view:open', function() {
        setTimeout(() => {
            ARNCUSTOM.SetProductQuickView = new ArnSetProduct('quick-view')
            ARNCUSTOM.SetProductQuickView.init()
        }, 100)
    })
    // add event for product add to cart sticky
    const buttonProductAddToCartSticky = document.querySelector('.product-add-to-cart-sticky--inner')
    if (buttonProductAddToCartSticky) {
        buttonProductAddToCartSticky.addEventListener('click', function () {
            setTimeout(() => {
                if (!ARNCUSTOM.SetProductSticky) {
                    ARNCUSTOM.SetProductSticky = new ArnSetProduct('sticky')
                    ARNCUSTOM.SetProductSticky.init()
                }
            }, 100)
        });
    }
    // set property = true when complete load 
    if (typeof ARNSTATE === 'undefined') ARNSTATE = {};
    ARNSTATE.loadCompletely = true;
}
setTimeout(() => {
    initCallerCustomization()
}, 1500)